import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'if_yes_does_the_fac_follow_any_of_the_following_practices_regar'

export const dataPointDefinition = {
  retracedId: 'if_yes_does_the_fac_follow_any_of_the_following_practices_regar',
  name: 'If yes, does the facility follow any of the following practices regarding deductions:',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'DEDUCTIONS_ARE_VOLUNTARILY_ACCEPTED_BY_WORKERS',
      text: 'Deductions are voluntarily accepted by workers',
      externalIds: [
        {
          id: 'wb-19--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_SIGN_A_DOCUMENT_IN_A_LANGUAGE_THEY_UNDERSTAND_GIVING_CO',
      text: 'Workers sign a document (in a language they understand) giving consent for monies to be deducted',
      externalIds: [
        {
          id: 'wb-19--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DEDUCTIONS_TO_WAGES_ARE_EXPLAINED_TO_WORKERS',
      text: 'Deductions to wages are explained to workers',
      externalIds: [
        {
          id: 'wb-19--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_HAVE_ACCESS_TO_THE_ACCOUNT_STATUS_OF_ALL_WAGE_DEDUCTION',
      text: 'Workers have access to the account status of all wage deductions (i.e. history of payments, current account balances etc.)',
      externalIds: [
        {
          id: 'wb-19--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wb-19--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'IS_THE_FACILITY_FAILING_TO_COLLECT_AND_FORWARD_SOCIAL_INSURANCE',
      text: 'Is the facility failing to collect and forward social insurance or social security contributions for workers in line with legal requirements?',
      externalIds: [
        {
          id: 'wb-wage-65',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NOT_APPLICABLE_WORKER_AND_FACILITY_CONTRIBUTIONS_CANNOT_BE_SEPA',
      text: 'Not applicable - worker and facility contributions cannot be separated and/ or broken down',
      externalIds: [
        {
          id: 'wb-wag-107x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE_FACILITY_COLLECTS_AND_FORWARDS_ALL_LEGALLY_RE',
      text: 'None of the above (facility collects and forwards all legally required contributions in line with legal requirements)',
      externalIds: [
        {
          id: 'wb-wage-74',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TOTAL_WORKER_CONTRIBUTION_AMOUNT_NO_BREAKDOWN_POSSIBLE_COLLECTE',
      text: 'Total worker contribution amount (no breakdown possible) collected and forwarded is in line with legal requirements',
      externalIds: [
        {
          id: 'wb-wag-108x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'DEDUCTIONS_ARE_VOLUNTARILY_ACCEPTED_BY_WORKERS',
                'WORKERS_SIGN_A_DOCUMENT_IN_A_LANGUAGE_THEY_UNDERSTAND_GIVING_CO',
                'DEDUCTIONS_TO_WAGES_ARE_EXPLAINED_TO_WORKERS',
                'WORKERS_HAVE_ACCESS_TO_THE_ACCOUNT_STATUS_OF_ALL_WAGE_DEDUCTION',
                'NONE_OF_THE_ABOVE',
                'IS_THE_FACILITY_FAILING_TO_COLLECT_AND_FORWARD_SOCIAL_INSURANCE',
                'NOT_APPLICABLE_WORKER_AND_FACILITY_CONTRIBUTIONS_CANNOT_BE_SEPA',
                'NONE_OF_THE_ABOVE_FACILITY_COLLECTS_AND_FORWARDS_ALL_LEGALLY_RE',
                'TOTAL_WORKER_CONTRIBUTION_AMOUNT_NO_BREAKDOWN_POSSIBLE_COLLECTE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-48',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8860,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
